"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var DialogMode;
(function (DialogMode) {
    DialogMode["Extractor"] = "Extract";
    DialogMode["Scorer"] = "Score";
    DialogMode["Wait"] = "Wait";
    DialogMode["EndSession"] = "EndSession"; // Dialog is over - EndSesssion Action has been called
})(DialogMode = exports.DialogMode || (exports.DialogMode = {}));
//# sourceMappingURL=Teach.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@conversationlearner/models/dist/Teach.js
// module id = 739
// module chunks = 0